"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxStable = void 0;
const react_1 = __importDefault(require("react"));
// fixme it's dependency used there and in radio-group
const FormGroup_1 = __importDefault(require("react-bootstrap/FormGroup"));
const FormLabel_1 = __importDefault(require("react-bootstrap/FormLabel"));
const classFunctions_1 = require("../../utils/classFunctions");
const flatArray_1 = require("../../utils/flatArray");
const Icon_1 = require("../Icon");
require("./index.scss");
const className = 'checkbox';
const CheckBoxStable = (props) => {
    const { nativeValue, onChange, onFocus, autoFocus, name, textLeft, textRight, error, disabled, hidden, additionClassNames, modificators, } = props;
    const errorElements = (0, flatArray_1.flatArray)(error);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        errorElements ? 'error' : undefined,
    ], additionClassNames);
    const containerClassNames = (0, classFunctions_1.getClassNames)(`${className}__container`, [
        disabled ? 'disabled' : undefined,
    ]);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(FormGroup_1.default, null,
            react_1.default.createElement(FormLabel_1.default, { className: containerClassNames },
                react_1.default.createElement("input", { checked: nativeValue, onChange: onChange, onFocus: onFocus, autoFocus: autoFocus, name: name, disabled: disabled, className: `${className}__value`, type: 'checkbox' }),
                textLeft ? (react_1.default.createElement("span", { className: `${className}__text` }, textLeft)) : null,
                react_1.default.createElement("span", { "data-target": 'checkbox', className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-mark' })),
                textRight ? (react_1.default.createElement("span", { className: `${className}__text` }, textRight)) : null))));
};
exports.CheckBoxStable = CheckBoxStable;
//# sourceMappingURL=stable.js.map